import React from 'react';
import {FlexContainer} from 'app/styles/content';
import styled from 'styled-components';

const Container = styled(FlexContainer)`
  a {
    flex: 1;
  }
`;

const Tiles = ({children}) => {
  return <Container>{children}</Container>;
};

export default Tiles;
